import { render, staticRenderFns } from "./overrideDeductions.vue?vue&type=template&id=d7ba4190&scoped=true"
import script from "./overrideDeductions.vue?vue&type=script&lang=js"
export * from "./overrideDeductions.vue?vue&type=script&lang=js"
import style0 from "./overrideDeductions.vue?vue&type=style&index=0&id=d7ba4190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ba4190",
  null
  
)

export default component.exports